import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import { ClipboardPlugin } from '@/plugins/clipboard';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import pagination from '@/components/pagination.vue';
import JsonCode from '@/components/code-mirror.vue';
import copy from '@/components/copy.vue';
import chart from '@/components/chart.vue';
import { Can, abilitiesPlugin } from '@casl/vue';
import ability from './casl/ability'
import ThreeModel from '@/components/three-model/index.vue';


/**
 * 百度地图
 * 经过测试
 * vue-bmap-gl vue-mapvgl使用按需导入只保留4个组件的情况下，能节省大概 3 M ，暂时性采用全部导入
 * 
 * -----------------------------------------------------
 * 百度地图全包导入和3D模型展示的依赖库 threejs 版本冲突，可能出现其他问题，改为自动导入
 * import { ElBmap } from 'vue-bmap-gl'
 * import { ElBmapvView, ElBmapvIconLayer, ElBmapvTextLayer } from 'vue-mapvgl'
 * -----------------------------------------------------
 */
// import { initBMapApiLoader } from 'vue-bmap-gl';

// 以下为全部导入
// import VueBMap, { initBMapApiLoader } from 'vue-bmap-gl';
import 'vue-bmap-gl/dist/style.css'
// import VueMapvgl from 'vue-mapvgl'
import { ElBmap } from 'vue-bmap-gl'
import { ElBmapvView, ElBmapvIconLayer, ElBmapvTextLayer, ElBmapvCircleLayer } from 'vue-mapvgl'
// 百度开发注册 2025-12 收费停用
// TODO 
// initBMapApiLoader({
//     // ak: 'tabVMcwEdXQLS5GabwNn9cOxRLLwkBIH',// 个人开发者配置密钥
//     v: '1.0',
//     type: 'webgl',
// })
// 取消以下 全部导入
// app.use(VueBMap).use(VueMapvgl);

const app = createApp(App)


app.component('bmap', ElBmap)
app.component('bmapv-view', ElBmapvView)
app.component('bmapv-icon-layer', ElBmapvIconLayer)
app.component('bmapv-text-layer', ElBmapvTextLayer)
app.component('bmapv-circle-layer', ElBmapvCircleLayer)

/**
 * 注册全局组件
 */
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

/**
 * 此种方式配合element-plus中的table使用
 */
app.provide(/* 注入名 */ '$formatDate', /* 值 */(stamp: string) => {
    return stamp ? moment(stamp).format('YYYY-MM-DD HH:mm:ss') : '/';
})

/**
 * 声明文件，避免代码中错误提示
 */
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $getUrlByUuid: (uuid: string) => string
    }
}
app.config.globalProperties.$getUrlByUuid = (resourceUUID = '') => {
    if (!resourceUUID) { return '' }
    if (resourceUUID.startsWith('http')) {
        return resourceUUID;
    }
    return '/api/assets/cloud/' + resourceUUID;
}

// 在这里使用插件来注册全局组件、指令、混入等内容
app.use(ClipboardPlugin, {
    // 这里可以传递可选的配置项，例如成功和失败消息的文本
});

// 注册自定义分页组件
app.component('pagination', pagination);
// json-code 代码编辑器
app.component('json-code', JsonCode);
//  copy 复制文本
app.component('copy', copy);

app.component('chart', chart);

// casl 管理
app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true
}).component(Can.name as string, Can);



// 注册 three-modle
app.component('three-model', ThreeModel);

app.use(router).use(store).use(ElementPlus, { locale: zhCn, size: 'small' }).mount('#app')
